import { Globe } from "lucide-react";
import { LANGS, getLang, setLang, _t } from "@/lib/i18n";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const LanguageSwitcher = () => {
  const { user } = useAuth();
  const current = getLang();
  const onChange = async (e) => {
    const code = e.target.value;
    if (user) { try { await api.put("/auth/me/lang", { lang: code }); } catch { /* UI choice still applies */ } }
    setLang(code);
  };
  return (
    <label className="relative inline-flex items-center gap-1.5 rounded-full border border-white/15 px-2.5 py-1.5 text-xs text-white/80 hover:border-[#FF5722] transition-colors cursor-pointer" title={_t("Lingua")}>
      <Globe className="w-3.5 h-3.5" />
      <span>{LANGS.find((l) => l.code === current)?.short}</span>
      <select data-testid="language-switcher" aria-label={_t("Lingua")} value={current} onChange={onChange} className="absolute inset-0 opacity-0 cursor-pointer">
        {LANGS.map((l) => <option key={l.code} value={l.code} data-testid={`language-option-${l.code}`}>{l.label}</option>)}
      </select>
    </label>
  );
};

export const LegalTranslationNotice = () =>
  getLang() === "it" ? null : (
    <div data-testid="legal-translation-notice" className="mb-6 rounded-xl border border-amber-400/30 bg-amber-500/5 px-4 py-3 text-xs text-amber-100/90">
      {_t("Traduzione di cortesia: in caso di differenze fa fede la versione italiana.")}
    </div>
  );
